export const preparedOptionsValue = (option, options) => {
    return option && options ? options[option] : '-';
};
export const preparedValue = (value) => value || '-';
